import { useContext } from "react";


import { Navigate, Outlet, useLocation } from "react-router-dom";

// ----> USER CONTEXT IMPORTATION
import { UserContext } from "../../context/UserContext.jsx";


// components importation
import { NavBarComp } from "../../components/navbar-comp/NavBarComp.jsx";





export const ProtectedRoutes = () => {

  // get user context
  const { user } = useContext(UserContext);

  const { pathname, search } = useLocation();


  if (!user || !Object.keys(user).length) {
    if (pathname === "/create-case") {
      localStorage.setItem("prevLoc", `${pathname}${search}`);
    }
    return <Navigate to="/" />
  }

  return (
    <>
      <NavBarComp />
      <div className="grid-wrapper">
        <Outlet />
      </div>
    </>
  );
};